import moment from "moment";
import "./MyFinancials.scss";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../Contexts/auth.context";
import Loading from "../../../../components/loading/loading.component";
import {
  getInfluencerAuctionEarning,
  getInfluencerExchangeEarning,
  getInfluencerFee,
  getTierInfo,
} from "../../../../Services/prod/auth.service";
import { CMAuctions } from "../../../Public/billing-history/billing-history.styles";
import { formatCommaNumbers } from "../../../../Utils/common.utils";

const MyFinancials = ({ activeTab }) => {
  // *********** STATES ***********
  const limit = 10;
  const { auth } = useAuth();
  const [feeData, setFeeData] = useState({});
  const [loading, setLoading] = useState(true);
  const [auctionPage, setAuctionPage] = useState(1);
  const [auctionData, setAuctionData] = useState({});
  const [exchangePage, setExchangePage] = useState(1);
  const [exchangeData, setExchangeData] = useState({});
  const [tierInfo, setTierInfo] = useState({
    tier1_min: 0,
    tier1_max: 0,
    tier2_min: 0,
    tier2_max: 0,
    tier3_min: 0,
    tier3_max: 0,
  });

  const actiondata = [
    {
      tier: "1",
      listeners: `${formatCommaNumbers(tierInfo?.tier1_min)} 
        to ${formatCommaNumbers(tierInfo?.tier1_max)}`,
      commission: feeData?.influencer_fee
        ? feeData?.influencer_fee?.first_tier_fee || 0
        : feeData?.global_tier_fee?.first_tier_fee || 0,
    },
    {
      tier: "2",
      listeners: `${formatCommaNumbers(tierInfo?.tier2_min)}
         to ${formatCommaNumbers(tierInfo?.tier2_max)}`,
      commission: feeData?.influencer_fee
        ? feeData?.influencer_fee?.second_tier_fee || 0
        : feeData?.global_tier_fee?.second_tier_fee || 0,
    },
    {
      tier: "3",
      listeners: `${formatCommaNumbers(tierInfo?.tier3_min)} 
        to ${formatCommaNumbers(tierInfo?.tier3_max)}`,
      commission: feeData?.influencer_fee
        ? feeData?.influencer_fee?.third_tier_fee || 0
        : feeData?.global_tier_fee?.third_tier_fee || 0,
    },
  ];
  // *********** GET INFLUENCER FINANCIAL EARNING ***********
  useEffect(() => {
    const financialDeatils = async () => {
      try {
        if (auth?.userId) {
          const [auctionEarningRes, exchangeEarningRes, feeRes] =
            await Promise.all([
              getInfluencerAuctionEarning(auctionPage, limit),
              getInfluencerExchangeEarning(exchangePage, limit),
              getInfluencerFee(auth?.userId),
            ]);
          if (
            auctionEarningRes?.status === 200 &&
            exchangeEarningRes?.status === 200 &&
            feeRes
          ) {
            setLoading(false);
            setAuctionData(auctionEarningRes?.data?.auction_financial_report);
            setExchangeData(
              exchangeEarningRes?.data?.exchange_financial_report
            );
            setFeeData(feeRes?.data);
          }
        }
      } catch (error) {
        setLoading(false);
        console.log(error, "error");
      }
    };
    if (activeTab === "my-financials") {
      financialDeatils();
    }
  }, [activeTab]);

  // *********** HANDLE PAGE FOR AUCTION REPORT ***********
  const handlePageAuction = ({ selected }) => {
    setAuctionPage(selected + 1);
  };

  // *********** HANDLE PAGE FOR EXCHANGE REPORT ***********
  const handlePageExchange = ({ selected }) => {
    setExchangePage(selected + 1);
  };

  // *********** TIER INFO ***********
  useEffect(() => {
    const tierInfo = async () => {
      const createFeesRes = await getTierInfo();
      setTierInfo(createFeesRes[0]);
    };
    if (activeTab === "my-financials") {
      tierInfo();
    }
  }, [activeTab]);

  return (
    <div className="my_finance_tab">
      <div className="my_finance_tab_box">
        {loading ? (
          <Loading />
        ) : (
          <>
            <Table responsive className="custom_table">
              <thead>
                <tr>
                  <th>Auction Name</th>
                  <th>Auction ID</th>
                  <th>Commission</th>
                  <th>Transfer Date</th>
                </tr>
              </thead>
              <tbody>
                {auctionData && auctionData?.rows?.length > 0 ? (
                  auctionData?.rows?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Link to="#" rel="noreferrer" >
                            {item?.auction
                              ? item?.auction?.listing_name
                              : "N/A"}
                          </Link>
                        </td>
                        <td>
                          <Link to="#" rel="noreferrer" >
                            {item?.auction_id ? item?.auction_id : "N/A"}
                          </Link>
                        </td>
                        <td>
                          {item?.total_net_amount
                            ? `$${item?.total_net_amount}`
                            : "$0"}{" "}
                          {item?.fee ? `(${item?.fee}%)` : "(0%)"}
                        </td>
                        <td>
                          {item?.updated_at
                            ? moment(item?.updated_at).format(
                                "DD/MM/YYYY"
                              )
                            : "N/A"}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center"
                      style={{ "text-align": "center" }}
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <Table responsive className="custom_table symbol_table">
              <thead>
                <tr>
                  <th>Symbol Name</th>
                  <th>Symbol ID</th>
                  <th>Commission</th>
                  <th>Transfer Date</th>
                </tr>
              </thead>
              <tbody>
                {exchangeData && exchangeData?.rows?.length > 0 ? (
                  exchangeData?.rows?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Link to="#" rel="noreferrer" >
                            {item?.symbol_name
                              ? item?.symbol_name?.toUpperCase()
                              : "N/A"}
                          </Link>
                        </td>
                        <td>
                          <Link to="#" rel="noreferrer" >
                            {item?.symbol_name
                              ? item?.symbol_name?.toUpperCase()
                              : "N/A"}
                          </Link>
                        </td>
                        <td>
                          {item?.total_net_amount
                            ? `$${item?.total_net_amount}`
                            : "$0"}{" "}
                          {item?.fee ? `(${item?.fee}%)` : "(0%)"}
                        </td>
                        <td>
                          {item?.updated_at
                            ? moment(item?.updated_at).format("DD/MM/YYYY")
                            : "N/A"}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center"
                      style={{ "text-align": "center" }}
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {auctionData?.count > limit && (
              <CMAuctions>
                <section className="pagination custom_pagination">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    previousLabel="<"
                    onPageChange={handlePageAuction}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(auctionData?.count / limit)}
                    renderOnZeroPageCount={null}
                    // previousClassName={auctionPage === 0 ? "disabled" : ""}
                    // nextClassName={
                    //   auctionPage === Math.ceil(auctionData?.count / limit) - 1
                    //     ? "disabled"
                    //     : ""
                    // }
                  />
                </section>
              </CMAuctions>
            )}
            {exchangeData?.count > limit && (
              <CMAuctions>
                <section className="pagination custom_pagination">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    previousLabel="<"
                    onPageChange={handlePageExchange}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(exchangeData?.count / limit)}
                    renderOnZeroPageCount={null}
                    // previousClassName={exchangePage === 0 ? "disabled" : ""}
                    // nextClassName={
                    //   exchangePage ===
                    //   Math.ceil(exchangeData?.count / limit) - 1
                    //     ? "disabled"
                    //     : ""
                    // }
                  />
                </section>
              </CMAuctions>
            )}
          </>
        )}
      </div>
      <hr className="custom_hr auction_table_hr" />
      <div className="my_finance_tab_box">
        <h3>Auction Commissions</h3>
        <Table className="auction_table" responsive>
          <thead>
            <tr>
              <th>Tier</th>
              <th>Monthly Listeners</th>
              <th>Commission</th>
            </tr>
          </thead>
          <tbody>
            {actiondata &&
              actiondata?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>Tier {item?.tier}</td>
                    <td>{item?.listeners}</td>
                    <td>
                      {" "}
                      <span className="commission_box fit-width">
                        {item?.commission}
                      </span>
                      %{" "}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
      <div className="my_finance_tab_box">
        <hr className="custom_hr market_hr" />
        <div className="market">
          <h3>Secondary Market Commissions</h3>
          <p>
            Our commissions are based on successful transactions made within a
            6-month period after your referred users to register on the
            MusicBull platform. Our standard commission rate is 1%. If you
            believe you can bring unique value, you may submit a different
            commission rate for consideration, and we will review your request.
          </p>
          <div className="auction_table">
            <Table responsive>
              <thead>
                <tr>
                  <th>Commission</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {" "}
                    <span className="commission_box fit-width">
                      {feeData?.influencer_fee
                        ? feeData?.influencer_fee?.secondary_market_fee
                        : feeData?.global_tier_fee?.secondary_market_fee}
                    </span>
                    %{" "}
                  </td>
                </tr>
              </tbody>
            </Table>
            {/* <Link to="#" className="unsubscribe_link">
              Unsubscribe
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyFinancials;
